import React, { useMemo } from "react";
import AppPage from "../../../../components/CustomUI/AppPage";
import { ToastContainer, Toast } from "../../../../components/CustomUI/Toast";
import Select from "../../../../components/BaseUI/Select";
import "../Reports.scss";

const SalesReportShell = ({
  title,
  year,
  years = [],
  onYearChange,
  showMonthFilter = false,
  month = "all",
  monthOptions = [],
  onMonthChange,
  toasts,
  dismissToast,
  children,
}) => {
  const yearOptions = useMemo(
    () => years.map((y) => ({ value: String(y), label: String(y) })),
    [years],
  );

  return (
    <AppPage title="">
      <ToastContainer>
        {toasts.map((t) => (
          <Toast
            key={t.id}
            title={t.message}
            appearance={t.type === "danger" ? "danger" : "success"}
            onClose={() => dismissToast(t.id)}
          />
        ))}
      </ToastContainer>

      <div className="card card-body py-2 px-3 mb-4 reports-filter-shell rp-year-filter-bar">
        <div className="d-flex justify-content-between align-items-center gap-3 flex-wrap">
          <h1 className="title-page mb-0 rp-year-filter-bar__title">{title}</h1>
          <div className="rp-year-filter-group d-flex align-items-center gap-2">
            {showMonthFilter && (
              <div className="rp-year-filter rp-year-filter--month">
                <div className="list-filters__control list-filters__control--select">
                  <Select
                    className="mb-0"
                    label=""
                    unique
                    placeholder="Ay seçin"
                    disabled={monthOptions.length === 0}
                    options={monthOptions}
                    selected={[String(month)]}
                    onSelected={(vals) =>
                      onMonthChange?.(String(vals?.[0]?.value ?? month))
                    }
                  />
                </div>
              </div>
            )}
            <div className="rp-year-filter">
              <div className="list-filters__control list-filters__control--select">
                <Select
                  className="mb-0"
                  label=""
                  unique
                  placeholder="Yıl seçin"
                  disabled={years.length === 0}
                  options={yearOptions}
                  selected={[String(year)]}
                  onSelected={(vals) =>
                    onYearChange(Number(vals?.[0]?.value ?? year))
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {children}
    </AppPage>
  );
};

export default SalesReportShell;
